enum CommunicationPreferenceFieldType {
    PreferredLanguage = 'PreferredLanguage',
    PreferredContactMethod = 'PreferredContactMethod',
    PreferredEmail = 'PreferredEmail',
    PreferredPhone = 'PreferredPhone',
}

export default CommunicationPreferenceFieldType;
